import { CompanyAutoSuggest } from 'app/employer/components/autoSuggest';
import withAutoSuggestFormik from './withAutoSuggestFormik';

export default withAutoSuggestFormik(CompanyAutoSuggest);
